import React from 'react';
import PropTypes from 'prop-types';
import './Tabs.scss';
import { OrderTypeCodeMapping } from '../../constants';

const staticText = {
  step1: 'STEP 1',
  step2: 'STEP 2',
  step3: 'STEP 3',
  step4: 'STEP 4',
  customerInfo: 'Customer Info',
  choosePlan: 'Choose Plan',
  search: 'Search',
  products: 'Products',
  slotPatient: 'Slot + Patient',
  selectDoctor: 'Select Doctor',
  samplePickup: 'Sample Pickup Address',
  delivery: 'Delivery Address',
  slotPatientDetails: 'Slot + Patient Details',
  slotReview: 'Slot Selection & Review',
  rxAvailable: 'Rx Available',
};

const Tabs = ({ tabs: { tabStates }, orderType }) => (
  <div className="TabsContainer">
    <div className={`TabsItemContainer ${tabStates[0] ? 'selectedTabsItem' : ''}`}>
      <div className="TabsItemText">{staticText.step1}</div>
      <div className="TabsItemDetail">{staticText.customerInfo}</div>
    </div>
    <div className={`TabsItemContainer ${tabStates[1] ? 'selectedTabsItem' : ''}`}>
      <div className="TabsItemText">{staticText.step2}</div>
      <div className="TabsItemDetail">{orderType === OrderTypeCodeMapping.otcOrder ? staticText.choosePlan : (orderType === OrderTypeCodeMapping.docConsultOrder ? staticText.search : staticText.products)}</div>
    </div>
    <div className={`TabsItemContainer ${tabStates[2] ? 'selectedTabsItem' : ''}`}>
      <div className="TabsItemText">{staticText.step3}</div>
      <div className="TabsItemDetail">{orderType === OrderTypeCodeMapping.otcOrder ? staticText.slotPatient : (orderType === OrderTypeCodeMapping.docConsultOrder ? staticText.selectDoctor : (orderType ? staticText.samplePickup : staticText.delivery))}</div>
    </div>
    {orderType !== OrderTypeCodeMapping.otcOrder && (
      <div className={`TabsItemContainer ${tabStates[3] ? 'selectedTabsItem' : ''}`}>
        <div className="TabsItemText">{staticText.step4}</div>
        <div className="TabsItemDetail">{orderType === OrderTypeCodeMapping.docConsultOrder ? staticText.slotPatientDetails : (orderType ? staticText.slotReview : staticText.rxAvailable)}</div>
      </div>
    )}
  </div>
);

Tabs.propTypes = {
  tabs: PropTypes.object.isRequired,
  orderType: PropTypes.number,
};

Tabs.defaultProps = {
  orderType: 0,
};

export default Tabs;
